// extracted by mini-css-extract-plugin
export default {"unread-channels-list":"chat_unread-channels-list__vZVHS","header-title":"chat_header-title__Yd9mm"};